import React, { Component, useState, useEffect  } from "react";
import { useNavigate, useLocation } from 'react-router-dom'

import CryptoJS from "crypto-js";


{/*import "../css/login.css";*/}


function Appsmenu(props) {

const awcurl=sessionStorage.getItem("AWC_URL");
const resturl=sessionStorage.getItem("REST_URL");
const appsurl=sessionStorage.getItem("APPS_URL");

useEffect(() => {
	document.title =   "Dashboard";	
	
		if (!sessionStorage.getItem("AW_USERNAME")){
	navigate("../logout");
	return;
	}
	
	if (!document.getElementsByTagName('body')[0].classList.contains("dashboardbody"))
		document.getElementsByTagName('body')[0].classList.add("dashboardbody");
	console.log("resturl: "+resturl);
},[]);



const navigate = useNavigate();	

const location = useLocation();
console.log('location.pathname: '+location.pathname);
console.log('window.location: '+window.location);


function openapp(e, apppath){
e.preventDefault(); 
document.getElementsByTagName('body')[0].classList.remove("loginbody");	
navigate('/'+apppath);
}//end func





function openwindow(e, app){
	e.preventDefault();

/*
	if (app=='apot'){
		alert('sorry.  APOT is not available here as yet.');
		return;
		}
*/

if (app=='concessions'){
	const conssnUrl=sessionStorage.getItem("APPS_URL")+"concessions/";
	console.log("concessions url: "+conssnUrl);
	window.open(conssnUrl);//'http://localhost/benef/index.jsp'
	//child window will call parent as below
	//window.parent.document.getElementsByName('input1')[0].value;
	}//end if

}//end func


function openremappOld(e, res, app){
	
	
	console.log('openremapp res: '+JSON.stringify(res));
	
	const jsonObj={
		userid:sessionStorage.getItem("AW_USERID")
		, email: sessionStorage.getItem("GOV_EMAIL")
		, ip:res.IPv4
		, passwd: Math.random().toString(36).slice(2)
		, app:app
	};
	
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( jsonObj )
  };


  fetch(appsurl+'rarlogin/openremapp',requestOptions)
      .then(res => res.json())
      .then(res => afteropenremapp(res))
      .catch(err => console.log(err));	
	

}//end func

function afteropenremapp(res){
	//console.log('afteropenremapp res: '+JSON.stringify(res));
	if (res.length>0){
		const url=res[0].URL;
		console.log('afteropenremapp url: '+url);
		window.open(url);
		}
}//end func

 const AW_USERNAME=sessionStorage.getItem("AW_USERNAME");

    return (
		<>
		
	  		
       <div align="center"  className="numcols3-1" >
                <div className="rcorners">
                    <a href="#" onClick={(e)=>{openapp(e, 'jobqadm')}}  >
                    <table border="0" width="100%"  >
					<tbody>
                    <tr valign="top">
                    <td align="left" rowSpan="2" width="72"  >
                    <img src="img/apps/jobq.png" border="0" title="" />
                    </td>
                    <td align="left" className="boxtitle" >Job Queue</td>
                    </tr>
                    <tr>
                    <td align="left" className="boxtext" >Check and Trigger Select Declarations<br/>Create Payment Vouchers</td>
                    </tr>
					</tbody>
                    </table>
                    </a>
                </div>
        </div>
        <div align="center"  className="numcols3-2" >
                <div className="rcorners">
                    <a href="#" onClick={(e)=>{openapp(e, 'sadfinder')}}  >
                    <table border="0" width="100%"  >
					<tbody>
                    <tr valign="top">
                    <td align="left" rowSpan="2" width="72"  >
                    <img src="img/apps/searchdb.png" border="0" title="" />
                    </td>
                    <td align="left" className="boxtitle" >SAD Finder</td>
                    </tr>
                    <tr>
                    <td align="left" className="boxtext" >Search, Clear and Re-Route<br/>Declarations</td>
                    </tr>
					</tbody>
                    </table>
                    </a>
                </div>
		</div>
		
        <div align="center"  className="numcols3-3" >
                <div className="rcorners">
				{/*<a href="#" onClick={(e)=>{openapp(e, 'intairbill')}}  >*/}
				<a href="#" onClick={(e)=>{openapp(e, 'exitnote')}}  >
                    <table border="0" width="100%"  >
					<tbody>
                    <tr valign="top">
                    <td align="left" rowSpan="2" width="72"  >
                    <img src="img/apps/truck.png" border="0" title="" />
                    </td>
                    <td align="left" className="boxtitle" >Exit Notes</td>
                    </tr>
                    <tr>
                    <td align="left" className="boxtext" >Create Exit Notes<br/>&nbsp;</td>
                    </tr>
					</tbody>
                    </table>
                    </a>
                </div>

		</div>
    
	
       <div align="center"  className="numcols3-1" >
                <div className="rcorners">
                    <a href="#" onClick={(e)=>{openapp(e, 'inspact')}}  >
                    <table border="0" width="100%"  >
					<tbody>
                    <tr valign="top">
                    <td align="left" rowSpan="2" width="72"  >
                    <img src="img/apps/inspectionact.png" border="0" title="" />
                    </td>
                    <td align="left" className="boxtitle" >Inspection Acts</td>
                    </tr>
                    <tr>
                    <td align="left" className="boxtext" >View Inspection Acts created<br/>&nbsp;</td>
                    </tr>
					</tbody>
                    </table>
                    </a>
                </div>


        </div>
        <div align="center"  className="numcols3-2" >
				<div className="rcorners"  >
				<a href='#' onClick={(e)=>{openwindow(e, 'concessions');}} target="_none"  >
				
				<table border="0" width="100%"  >
				<tbody>
				<tr>
				<td align="left" rowSpan="2" width="72" >
				<img src="img/apps/taxcut.png" border="0" title="" />
				</td>
				<td align="left" className="boxtitle" >Concessions</td>
				</tr>
				<tr>
				<td align="left" className="boxtext" >Concessions Database<br/>&nbsp;</td>
				</tr>
				</tbody>
				</table>
				</a>
				</div>
		</div>
		


       <div align="center"  className="numcols3-1" >
                <div className="rcorners">
                    <a href="#" onClick={(e)=>{e.preventDefault(); window.open('https://cads.cclec.org/');}}  >
                    <table border="0" width="100%"  >
					<tbody>
                    <tr valign="top">
                    <td align="left" rowSpan="2" width="72"  >
                    <img src="img/apps/cads.png" border="0" title="" />
                    </td>
                    <td align="left" className="boxtitle" >CADS</td>
                    </tr>
                    <tr>
                    <td align="left" className="boxtext" >Customs Administrative Data System<br/>&nbsp;</td>
                    </tr>
					</tbody>
                    </table>
                    </a>
                </div>


        </div>
	
       <div align="center"  className="numcols3-2" >
                <div className="rcorners">
                    <a href="#" onClick={(e)=>{openapp(e, 'aduser')}}  >
                    <table border="0" width="100%"  >
					<tbody>
                    <tr valign="top">
                    <td align="left" rowSpan="2" width="72"  >
                    <img src="img/apps/cads.png" border="0" title="" />
                    </td>
                    <td align="left" className="boxtitle" >User Accounts</td>
                    </tr>
                    <tr>
                    <td align="left" className="boxtext" >User Accounts<br/>&nbsp;</td>
                    </tr>
					</tbody>
                    </table>
                    </a>
                </div>


        </div>


		{AW_USERNAME==AW_USERNAME && <div align="center"  className="numcols3-3" >
                <div className="rcorners">
                    <a href="#" onClick={(e)=>{openapp(e, 'trusteddevices')}}  >
                    <table border="0" width="100%"  >
					<tbody>
                    <tr valign="top">
                    <td align="left" rowSpan="2" width="72"  >
                    <img src="img/apps/cellphone.png" border="0" title="" />
                    </td>
                    <td align="left" className="boxtitle" >Trusted Devices</td>
                    </tr>
                    <tr>
                    <td align="left" className="boxtext" >Trusted Devices<br/>&nbsp;</td>
                    </tr>
					</tbody>
                    </table>
                    </a>
                </div>
		

        </div>	
		}
	<div id='snackbar' ></div>
	<input name="AD_USERNAME" value={sessionStorage.getItem("AD_USERNAME")} readOnly className="gnsbro" />
	<input name="LOGINTIME" value={sessionStorage.getItem("LOGINTIME")} type="hidden" />
	</>
);

}//end class

{
/*
onClick="document.getElementById('id01').style.display='none'"
onClick="document.getElementById('id01').style.display='none'"
*/
}

export default Appsmenu; 

